import type { ReactNode } from 'react';
import { useTranslations } from 'next-intl';
import { HeroProviderMark } from './HeroProviderLogos';

/**
 * The buy page's "<Category> Savings Applied" strip content. Verified via
 * ID.me / GovX, the provider's mark replaces the category icon and the label
 * credits the provider.
 */
export function HeroOfferTag({
  verifiedBy,
  icon,
  label,
}: {
  verifiedBy: 'idme' | 'govx' | null;
  icon: ReactNode;
  label: string;
}) {
  const t = useTranslations('common');
  return verifiedBy ? (
    <>
      <HeroProviderMark provider={verifiedBy} /> {label}{' '}
      {verifiedBy === 'idme'
        ? t('productSelectionSection.content.byIdme')
        : t('productSelectionSection.content.byGovx')}
    </>
  ) : (
    <>
      {icon} {label}
    </>
  );
}
